<div class="whatsapp-chat-container">
  <!-- Chat Header -->
  <div class="chat-header d-flex align-items-center justify-content-between">
    <div class="flex-grow-1 text-center">
      <h3 class="mb-0">Group Chat</h3>
    </div>
    <span class="close-chat" (click)="onCloseChat()">×</span>
  </div>
 
  <!-- Chat Messages -->
  <div class="chat-messages" #scrollContainer>
    <div *ngFor="let msg of messages"
      [ngClass]="{ 'my-message': msg.sender_id?.toString() === userId, 'other-message': msg.sender_id?.toString() !== userId }"
      class="chat-message">
 
      <div class="message-content">
 
        <!-- ✅ Show sender name only if not current user -->
        <div class="sender" *ngIf="msg.sender_id?.toString() !== userId">
          {{ msg.sender_name || ('User ' + msg.sender_id) }}
        </div>
 
        <p class="message-text">{{ msg.message }}</p>
 
        <div class="time">
          {{ msg.created_at | date: 'shortTime' }}
        </div>
      </div>
 
    </div>
  </div>
 
  <!-- Typing Indicator -->
  <div class="typing-indicator" *ngIf="typing">
    <em>{{ typing }}</em>
  </div>
 
  <!-- Chat Input -->
  <div class="chat-input">
    <textarea [(ngModel)]="newMessage" (input)="onInput()" placeholder="Type a message" rows="2">
    </textarea>
 
    <button (click)="sendMessage()" [disabled]="newMessage.trim() === ''">
      Send
    </button>
  </div>
</div>
 